import { AngularServices, getAngularService } from '../../core';
export const fetch = () => async (dispatch) => {
    const api = getAngularService(AngularServices.BannerUserAcknowledgeApi);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { $promise, $resolved, ...banners } = await api.getUnseen().$promise;
    dispatch({ type: 'BANNERS/SET_BANNERS', payload: banners });
};
export const acknowledge = (name, step) => async (dispatch) => {
    const api = getAngularService(AngularServices.BannerUserAcknowledgeApi);
    await api.acknowledge({ bannerName: name, bannerStepName: step }).$promise;
    dispatch({ type: 'BANNERS/ACK_BANNER', payload: { name, step } });
};
